function n(n,e,o,r){n._m(e);var t=o("5be30125");n._(e,"Inventory",t);}